"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginRender = void 0;
const react_1 = __importDefault(require("react"));
const ResourceBrowserInput_1 = require("../ResourceBrowserInput/ResourceBrowserInput");
const ResourceBrowserInlineButton_1 = require("../ResourceBrowserInlineButton/ResourceBrowserInlineButton");
const AuthProvider_1 = require("../ResourceBrowserContext/AuthProvider");
const PluginRender = ({ render, inline, inlineType, ...props }) => {
    if (render) {
        return (react_1.default.createElement(AuthProvider_1.AuthProvider, { authConfig: props.source }, inline && inlineType ? (react_1.default.createElement(ResourceBrowserInlineButton_1.ResourceBrowserInlineButton, { inlineType: inlineType, ...props })) : (react_1.default.createElement(ResourceBrowserInput_1.ResourceBrowserInput, { ...props }))));
    }
    else {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
};
exports.PluginRender = PluginRender;
